import { render, staticRenderFns } from "./HomeLawMasterStreak.vue?vue&type=template&id=52f8a258&scoped=true"
import script from "./HomeLawMasterStreak.vue?vue&type=script&lang=js"
export * from "./HomeLawMasterStreak.vue?vue&type=script&lang=js"
import style0 from "./HomeLawMasterStreak.vue?vue&type=style&index=0&id=52f8a258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f8a258",
  null
  
)

export default component.exports